const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "Masai School (Dec 2021-Present)",
    title: "Full Stack Web Development",
    desc: "The education should be very interactual. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
    rate: "4.30/5",
  },
  {
    id: 2,
    category: "education",
    year: "Ramashankar Krishak Mahavidyalaya (2018 - 2021), Deoria, Uttar Pradesh",
    title: "B.A",
    desc: "Maecenas finibus nec sem ut imperdiet. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
    rate: "4.50/5",
  },
  {
    id: 3,
    category: "education",
    year: "RSJP Inter College (2017 - 2018), Ballia, Uttar Pradesh ",
    title: "Senior Secondary(PCM)",
    desc: "If you are going to use a passage. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
    rate: "4.80/5 ",
  }
]

export default ResumeApi
